module.exports = __webpack_public_path__ + "static/media/20171212-_DSC2115_Small.e02f23c6.jpg";